import { render } from "./PaymentEkpay.vue?vue&type=template&id=ac70f49a"
import script from "./PaymentEkpay.vue?vue&type=script&lang=js"
export * from "./PaymentEkpay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__